module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "quillelement",
    staticClass: "quill-on-lesson"
  }, [_c('weip', {
    attrs: {
      "textInput": _vm.text,
      "isInTestOfSaveButton": false,
      "noteType": _vm.noteType
    },
    on: {
      "changed": _vm.changed
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serverText),
      expression: "serverText"
    }],
    staticClass: "none",
    attrs: {
      "name": 'event[' + _vm.noteType + ']',
      "id": 'event_' + _vm.noteType,
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.serverText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serverText = $event.target.value
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fca546b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quill/QuillOnLesson.vue
// module id = 1999
// module chunks = 1